export default "__VITE_ASSET__CfIP8vC___"